import type { RoutingStrategy } from '@/components/shipment/form/utils/shipment-form-routing';
import { getStopRoutingCoordinates } from '@/components/shipment/form/utils/shipment-form-stop-coords';
import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore';

export type LatLng = { lat: number; lng: number };

export function buildRoutingCoordinates(input: {
  strategy: RoutingStrategy;
  stops: readonly ShipmentFormStopRow[];
  trackerPosition: LatLng | null;
}): LatLng[] | null {
  if (input.strategy === 'none' || input.stops.length < 2) {
    return null;
  }

  const destination = input.stops[input.stops.length - 1]!;
  const destCoords = getStopRoutingCoordinates(destination);
  if (!destCoords) return null;

  if (input.strategy === 'trackerToDestination') {
    if (!input.trackerPosition) return null;
    return [input.trackerPosition, destCoords];
  }

  const coords: LatLng[] = [];
  for (const stop of input.stops) {
    const stopCoords = getStopRoutingCoordinates(stop);
    if (!stopCoords) return null;
    coords.push(stopCoords);
  }
  return coords;
}
